/* Kuori · Shop the look: pestañas + «Sube tu look».
   «Sube tu look» lee los colores de la foto AQUÍ, en el navegador (canvas + k-means pequeño en Lab); la foto no se
   envía a ningún sitio. Compara con assets/kuori-look-palettes.json (3–5 colores de la foto principal de cada funda). */
(() => {
  if (window.__kuoriLook) return;
  window.__kuoriLook = true;

  /* ---------- color ---------- */
  const lin = (c) => { c /= 255; return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92; };
  const lab = (r, g, b) => {
    const R = lin(r), G = lin(g), B = lin(b);
    let x = (R * 0.4124 + G * 0.3576 + B * 0.1805) / 0.95047;
    let y = R * 0.2126 + G * 0.7152 + B * 0.0722;
    let z = (R * 0.0193 + G * 0.1192 + B * 0.9505) / 1.08883;
    const f = (t) => (t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116);
    x = f(x); y = f(y); z = f(z);
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  };
  const hexLab = (hex) => {
    const n = parseInt(hex.replace('#', ''), 16);
    return lab((n >> 16) & 255, (n >> 8) & 255, n & 255);
  };
  const d2 = (a, b) => (a[0] - b[0]) ** 2 + (a[1] - b[1]) ** 2 + (a[2] - b[2]) ** 2;
  const toHex = (rgb) => '#' + rgb.map((v) => Math.round(v).toString(16).padStart(2, '0')).join('');

  // Píxeles que probablemente son piel o fondo blanco: cuentan menos (no se descartan, por si el outfit es beige o blanco)
  const isSkin = (r, g, b, L, A, Bb) => r > 95 && g > 40 && b > 20 && r > g && r > b && r - Math.min(g, b) > 15 && L > 35 && L < 88 && A > 6 && A < 32 && Bb > 10 && Bb < 38;

  const readColors = (img) => {
    const max = 140;
    const s = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    const w = Math.max(1, Math.round(img.naturalWidth * s));
    const h = Math.max(1, Math.round(img.naturalHeight * s));
    const canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    const data = ctx.getImageData(0, 0, w, h).data;
    const pts = []; const wts = []; const rgbs = [];
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const i = (y * w + x) * 4;
        if (data[i + 3] < 128) continue;
        const r = data[i], g = data[i + 1], b = data[i + 2];
        const p = lab(r, g, b);
        // el outfit suele estar en el centro de la foto
        const dx = (x / w - 0.5) / 0.5, dy = (y / h - 0.55) / 0.5;
        let wt = Math.max(0.15, 1 - 0.75 * (dx * dx + dy * dy));
        const chroma = Math.hypot(p[1], p[2]);
        if (p[0] > 92 && chroma < 6) wt *= 0.25; // fondo blanco
        if (isSkin(r, g, b, p[0], p[1], p[2])) wt *= 0.25;
        wt *= 0.6 + Math.min(chroma, 40) / 40; // los colores vivos del outfit pesan más que paredes y suelos
        pts.push(p); wts.push(wt); rgbs.push([r, g, b]);
      }
    }
    if (pts.length < 20) throw new Error('empty');
    // k-means ponderado, k = 5, arranque determinista por «el más lejano»
    const k = 5;
    const C = [pts[Math.floor(pts.length / 2)].slice()];
    const step = Math.max(1, Math.floor(pts.length / 1500));
    while (C.length < k) {
      let best = -1, bi = 0;
      for (let i = 0; i < pts.length; i += step) {
        let m = Infinity;
        for (const c of C) m = Math.min(m, d2(pts[i], c));
        const v = m * wts[i];
        if (v > best) { best = v; bi = i; }
      }
      C.push(pts[bi].slice());
    }
    const lab_ = new Int16Array(pts.length);
    for (let it = 0; it < 12; it++) {
      const sum = C.map(() => [0, 0, 0, 0]);
      for (let i = 0; i < pts.length; i++) {
        let m = Infinity, j = 0;
        for (let c = 0; c < k; c++) { const v = d2(pts[i], C[c]); if (v < m) { m = v; j = c; } }
        lab_[i] = j;
        const s_ = sum[j]; const wt = wts[i];
        s_[0] += pts[i][0] * wt; s_[1] += pts[i][1] * wt; s_[2] += pts[i][2] * wt; s_[3] += wt;
      }
      sum.forEach((s_, c) => { if (s_[3] > 0) C[c] = [s_[0] / s_[3], s_[1] / s_[3], s_[2] / s_[3]]; });
    }
    const out = C.map((c) => ({ lab: c, w: 0, rgb: [0, 0, 0], n: 0 }));
    let total = 0;
    for (let i = 0; i < pts.length; i++) {
      const o = out[lab_[i]]; o.w += wts[i]; total += wts[i];
      o.rgb[0] += rgbs[i][0]; o.rgb[1] += rgbs[i][1]; o.rgb[2] += rgbs[i][2]; o.n++;
    }
    return out
      .filter((o) => o.n > 0)
      .map((o) => ({ lab: o.lab, w: o.w / total, hex: toHex(o.rgb.map((v) => v / o.n)), neutral: Math.hypot(o.lab[1], o.lab[2]) < 10 }))
      .filter((o) => o.w >= 0.05)
      .sort((a, b) => b.w - a.w);
  };

  // Cuánto se parece cada color de la foto a la paleta de una funda. Los neutros (negro, blanco, gris) pesan
  // menos: casi todos los outfits llevan alguno y no deberían tapar el color protagonista.
  const labCache = new Map();
  const labOf = (hex) => { if (!labCache.has(hex)) labCache.set(hex, hexLab(hex)); return labCache.get(hex); };
  const contrib = (mine, palette) => mine.map((m) => {
    let s = 0;
    for (const [hex, pw] of palette) {
      const d = Math.sqrt(d2(m.lab, labOf(hex)));
      s += pw * Math.exp(-((d / 22) ** 2));
    }
    return s * m.w * (m.neutral ? 0.55 : 1);
  });
  // Elección variada: cada color de la foto que ya tiene funda cuenta menos para la siguiente
  const pick = (mine, pals, n) => {
    const pool = pals.map((p) => ({ h: p.h, c: contrib(mine, p.c) }));
    const used = mine.map(() => 0);
    const out = [];
    while (out.length < n && pool.length) {
      let bi = 0, bs = -1;
      pool.forEach((p, i) => {
        const s = p.c.reduce((a, v, j) => a + v * Math.pow(0.45, used[j]), 0);
        if (s > bs) { bs = s; bi = i; }
      });
      const p = pool.splice(bi, 1)[0];
      out.push(p);
      used[p.c.indexOf(Math.max(...p.c))]++;
    }
    return out;
  };

  /* ---------- tarjetas ---------- */
  // La tarjeta del tema (snippets/kuori-product-card: etiquetas, corazón, muestras, «+ Añadir»), pedida con la
  // Section Rendering API como en la página de favoritos: sale en el idioma, el mercado y la moneda de la clienta.
  const cards = new Map();
  const loadCard = (root, h) => {
    if (!cards.has(h)) {
      cards.set(h, fetch(`${root}/products/${encodeURIComponent(h)}?section_id=kuori-fav-card`, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : null))
        .then((html) => (html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.kfc-item .kpc') : null))
        .catch(() => null));
    }
    return cards.get(h);
  };
  const item = (card) => {
    const li = document.createElement('li');
    li.className = 'klk__item';
    li.append(document.importNode(card, true));
    return li;
  };

  /* ---------- pestañas ---------- */
  const initTabs = (sec) => {
    const tabs = [...sec.querySelectorAll('.klk__tab')];
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        let j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') j = 0;
        if (e.key === 'End') j = tabs.length - 1;
        if (j !== null) { e.preventDefault(); select(tabs[j], true); }
      });
    });
    // Editor de temas: al seleccionar un bloque, mostrar su look
    document.addEventListener('shopify:block:select', (e) => {
      const t = tabs.find((x) => x.id === `klk-tab-${e.detail.blockId}`);
      if (t) select(t);
    });
  };

  /* ---------- Sube tu look ---------- */
  const initUpload = (sec) => {
    const up = sec.querySelector('[data-klk-up]');
    if (!up) return;
    const input = up.querySelector('[data-klk-file]');
    const btn = input.closest('.klk-up__btn');
    const result = up.querySelector('[data-klk-result]');
    const error = up.querySelector('[data-klk-error]');
    const preview = up.querySelector('[data-klk-preview]');
    const chips = up.querySelector('[data-klk-chips]');
    const list = up.querySelector('[data-klk-matches]');
    const again = up.querySelector('[data-klk-again]');
    let palettes = null;
    let lastUrl = null;
    const cache = new Map();
    const root = sec.dataset.root.replace(/\/$/, '');
    const loadPalettes = () => palettes || (palettes = fetch(sec.dataset.palettes).then((r) => r.json()).then((j) => j.products || []).catch((e) => { palettes = null; throw e; }));
    const loadProduct = (h) => {
      if (!cache.has(h)) cache.set(h, fetch(`${root}/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null));
      return cache.get(h);
    };

    input.addEventListener('change', async () => {
      const file = input.files && input.files[0];
      if (!file) return;
      error.hidden = true;
      btn.classList.add('is-busy');
      try {
        if (lastUrl) URL.revokeObjectURL(lastUrl);
        lastUrl = URL.createObjectURL(file);
        const im = new Image();
        im.src = lastUrl;
        await im.decode();
        const mine = readColors(im);
        const pals = await loadPalettes();
        const ranked = pick(mine, pals, 10);
        const prods = (await Promise.all(ranked.map((r) => loadProduct(r.h)))).filter((p) => p && p.available).slice(0, 4);
        const found = (await Promise.all(prods.map((p) => loadCard(root, p.handle)))).filter(Boolean);
        if (!found.length) throw new Error('none');
        preview.src = lastUrl;
        chips.replaceChildren(...mine.slice(0, 5).map((c) => {
          const s = document.createElement('span');
          s.style.background = c.hex;
          s.title = c.hex;
          return s;
        }));
        list.replaceChildren(...found.map(item));
        result.hidden = false;
        up.classList.add('has-result');
        if (window.KuoriFav) window.KuoriFav.sync();
        document.dispatchEvent(new CustomEvent('kuori:cards:added', { detail: { root: list } }));
        result.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } catch (e) {
        error.hidden = false;
      } finally {
        btn.classList.remove('is-busy');
        input.value = '';
      }
    });
    again.addEventListener('click', () => input.click());
  };

  const start = () => document.querySelectorAll('[data-klk]:not([data-klk-ready])').forEach((sec) => {
    sec.setAttribute('data-klk-ready', '');
    initTabs(sec);
    initUpload(sec);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
